import { Vector3 } from 'three';

export const generatePositions = (count, min, max, minDistance) => {
    const cellSize = minDistance;
    const grid = new Map();
    const positions = [];

    const hash = (v) => {
        return `${Math.floor(v.x / cellSize)}|${Math.floor(v.y / cellSize)}|${Math.floor(v.z / cellSize)}`;
    };

    while (positions.length < count) {
        let newPos = new Vector3(
            Math.random() * (max.x - min.x) + min.x,
            Math.random() * (max.y - min.y) + min.y,
            Math.random() * (max.z - min.z) + min.z
        );

        let hashValue = hash(newPos);
        let tooClose = false;

        // Parse hash value to get grid coordinates
        const [gridX, gridY, gridZ] = hashValue.split('|').map(Number);

        for (let dx = -1; dx <= 1; dx++) {
            for (let dy = -1; dy <= 1; dy++) {
                for (let dz = -1; dz <= 1; dz++) {
                    let neighborPos = `${gridX + dx}|${gridY + dy}|${gridZ + dz}`;
                    let neighbor = grid.get(neighborPos);
                    if (neighbor && newPos.distanceTo(neighbor) < minDistance) {
                        tooClose = true;
                        break;
                    }
                }
                if (tooClose) break;
            }
            if (tooClose) break;
        }

        if (!tooClose) {
            positions.push(newPos);
            grid.set(hashValue, newPos);
        }
    }

    return positions;
};
